import {DEFAULT_SEARCH_KEY} from "@/lib/hooks/useDebouncedSearch.ts";
import {DEFAULT_FILTERS_KEY, resolveFilterSets} from "@/lib/hooks/useFilterSets.ts";
import {DEFAULT_OFFSET_KEY} from "@/lib/hooks/usePagination.ts";

export const ALERTS_ID_KEY = "pop";
export const ALERTS_LEGACY_ID_KEY = "show_id";
export const ALERTS_FILTERS_STORAGE_KEY = "alerts_list_filters";
const SERVICE_ID_KEY = "service_id";

/**
 * Rewrites Alert deep links (alert emails, Check "Alerts" links) into the keys `useTable` reads.
 * Returns undefined when the link has nothing to rewrite.
 */
export const normalizeAlertsDeepLinkParams = (params: URLSearchParams): URLSearchParams | undefined => {
  const alertId = params.get(ALERTS_ID_KEY) || params.get(ALERTS_LEGACY_ID_KEY);
  const serviceId = params.get(SERVICE_ID_KEY);
  const isUnappliedAlertLink = !!alertId && !params.has(DEFAULT_FILTERS_KEY);
  if (!isUnappliedAlertLink && !serviceId) {
    return undefined;
  }
  const normalized = new URLSearchParams(params);
  normalized.delete(SERVICE_ID_KEY);

  if (alertId) {
    // The Alert's row has to be on the page for its details modal to open, so stored filters stay out.
    if (isUnappliedAlertLink) {
      normalized.set(DEFAULT_SEARCH_KEY, params.get(DEFAULT_SEARCH_KEY) || alertId);
      normalized.set(DEFAULT_FILTERS_KEY, "{}");
    }
    return normalized;
  }

  const filterSets = resolveFilterSets(params.get(DEFAULT_FILTERS_KEY) || "", ALERTS_FILTERS_STORAGE_KEY);
  normalized.set(DEFAULT_FILTERS_KEY, JSON.stringify({...filterSets, services: [serviceId]}));
  normalized.delete(DEFAULT_OFFSET_KEY);
  return normalized;
};
